export const FORM_CURRENCIES = [
  'AUD',
  'CAD',
  'CHF',
  'DKK',
  'EUR',
  'GBP',
  'HRK',
  'HUF',
  'JPY',
  'NOK',
  'PLN',
  'RUB',
  'SEK',
  'USD'
]

export const FORM_OPERATIONS = [
  {
    'value': 'sell',
    'text': 'Chci prodat'
  },
  {
    'value': 'buy',
    'text': 'Chci koupit'
  }
]

export const EXCHANGE_FORMAT_REGEXP = '^\\d+([.,]\\d*)?$'
